import _ from 'underscore';
import {
  ageSettingOptions,
  genderSettingOptions
} from './target-options';

export function ageSettingOptionsFactory(isEligibleTypes) {
  if (isEligibleTypes) {
    return ageSettingOptions;
  }
  return _.defaults({
    selections: _.omit(ageSettingOptions.selections, 'Unknown'),
  }, ageSettingOptions);
}

export function genderSettingOptionsFactory(isAudienceCampaign) {
  if (isAudienceCampaign) {
    return genderSettingOptions;
  }
  return _.defaults({
    selections: _.omit(genderSettingOptions.selections, 'Unknown'),
  }, genderSettingOptions);
}
